import { SetStateAction, Dispatch, FC } from "react";

import {
  ExternalLinkConfirmation,
  BlockedLinkAlert,
} from "@zapier/rich-text-editor";

export interface ExternalLinkWarningProps {
  href: string;
  showLinkConfirmation: boolean;
  setShowLinkConfirmation: Dispatch<SetStateAction<boolean>>;
  showLinkBlocked: boolean;
  setShowLinkBlocked: Dispatch<SetStateAction<boolean>>;
}

export const ExternalLinkWarning: FC<ExternalLinkWarningProps> = ({
  href,
  showLinkConfirmation,
  setShowLinkConfirmation,
  showLinkBlocked,
  setShowLinkBlocked,
}) => {
  const handleContinue = () => {
    setShowLinkConfirmation(false);
    window.open(href, "_blank");
  };

  const handleCancel = () => {
    setShowLinkConfirmation(false);
  };

  const handleBlockedDismiss = () => {
    setShowLinkBlocked(false);
  };

  if (showLinkConfirmation) {
    return (
      <ExternalLinkConfirmation
        onCancel={handleCancel}
        onContinue={handleContinue}
      />
    );
  }

  if (showLinkBlocked) {
    return <BlockedLinkAlert onDismiss={handleBlockedDismiss} />;
  }
};
